import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  browserProfilingIntegration,
  browserTracingIntegration,
  extraErrorDataIntegration,
  init,
  setTag,
} from '@sentry/angular';
import { environment } from './environments/environment';
import { PortalComponent } from './portal/portal.component';
import { portalConfig } from './portal/portal.config';
import {
  sentryBeforeBreadcrumb,
  sentryIgnoreErrors,
  sentryTracePropagationTargets,
} from './shared/sentry/sentry-browser-options';

if (environment.production) {
  init({
    dsn: 'https://630d919edd9a086c3bcd47921e9dae95@o4506773953773568.ingest.sentry.io/4506773993422848',
    release: `joii@${environment.VERSION}`,
    dist: '1',
    integrations: [browserTracingIntegration(), browserProfilingIntegration(), extraErrorDataIntegration()],
    environment: environment.environment,
    attachStacktrace: true,
    ignoreErrors: sentryIgnoreErrors,
    beforeBreadcrumb: sentryBeforeBreadcrumb,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    tracePropagationTargets: sentryTracePropagationTargets,
    profilesSampleRate: 1.0,
  });
  setTag('app', environment.app);

  enableProdMode();
}

bootstrapApplication(PortalComponent, portalConfig).catch((err) => console.error(err));
